import React from 'react';
import { connect } from 'dva';
import { Steps, Modal, Input, Icon, Upload, message, ConfigProvider } from 'antd';
import { Toast } from 'antd-mobile';
import moment from 'moment';
import './listDetail.less';
import ZoomImg from '../../../components/mobile/zoomImg';
import zhCN from 'antd/lib/locale-provider/zh_CN';
const { TextArea } = Input;
const { Step } = Steps;
const imageFormat = 'png,jpeg,jpg,gif';
const fileTypes =
    '.png,.jpg,.jpeg,.gif,.bmp,.tiff,' +
    '.rmvb,.rm,.flv,.mp4,.mid,.3GP,.mpg,.mov,.mkv,.mp3,.wma,.wav,' +
    '.rar,.zip,.tar,.gz,.7z,.bz2,.cab,.iso,' +
    '.xls,.xlsx,.csv,.pdf,.doc,.docx,.odc,.txt,.wps,.et,.xps,.rtf,.ppt,.pptx,.otd';
const fileTypeStr = ['zip', 'rar', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'pdf', 'mp3', 'mp4', 'txt'];
const fileTypeList = [
    {
        type: 'zip',
        icon: '#iconyasuox',
    },
    {
        type: 'rar',
        icon: '#iconyasuox',
    },
    {
        type: 'doc',
        icon: '#iconWordx',
    },
    {
        type: 'docx',
        icon: '#iconWordx',
    },
    {
        type: 'ppt',
        icon: '#iconPptx',
    },
    {
        type: 'pptx',
        icon: '#iconPptx',
    },
    {
        type: 'xls',
        icon: '#iconExcelx',
    },
    {
        type: 'xlsx',
        icon: '#iconExcelx',
    },
    {
        type: 'pdf',
        icon: '#iconPDFx',
    },
    {
        type: 'mp3',
        icon: '#iconMpx1',
    },
    {
        type: 'mp4',
        icon: '#iconMpx',
    },
    {
        type: 'txt',
        icon: '#iconTxtx',
    },
];
let commitSign = false;
let revokeSign = false;
class ListDetail extends React.PureComponent {
    state = {
        show: false,
        showReply: false,
        showEvaluate: false,
        evaluateTxt: '',
        evaluateList: '',
        fileList: [],
        replyContent: '',
        evaluateVal: '',
        showContentImg: false, //顶部内容中的图片
    };

    componentDidMount() {
        const h = parseInt(window.getComputedStyle(document.querySelector('.zc-msgDetail-p')).height);

        if (
            h > 44 ||
            (this.props.messageDetail.length > 0 &&
                !!this.props.messageDetail[this.props.messageDetail.length - 1].fileList.length)
        ) {
            this.setState({
                show: true,
            });
        }
    }
   
    showModal = (key, list) => e => {
        e.preventDefault();
        this.setState({
            [key]: true,
        });
        if (key === 'showEvaluate') {
            this.setState({
                evaluateTxt: list[list.length - 1].scoreExplain,
            });
            this.setState({
                evaluateList: list,
            });
        }
    };
    closeModal = key => () => {
        this.setState({
            [key]: false,
        });
    };
    openImg = (item, flag) => {
        const { dispatch } = this.props;

        if (flag && !!item.target && item.target.tagName === 'IMG') {
            let imgSrc = item.target.src;

            dispatch({
                type: 'leaveMsg/update',
                payload: { zoomImgSrc: imgSrc, zoomImgDisplay: true },
            });
            return;
        }

        if (item.fileUrl) {
            dispatch({
                type: 'leaveMsg/update',
                payload: { zoomImgSrc: item.fileUrl, zoomImgDisplay: true },
            });
        }
    };
    renderStep = (item, list, index) => {
        const { flag, content, timeStr } = item;
        const date = moment(timeStr).format('MM-DD');
        const time = moment(timeStr).format('HH:mm');

        return (
            <div>
                <div className="timer">
                    <p className="date" style={{ fontSize: 12 }}>
                        {date}
                    </p>
                    <p className="time" style={{ fontSize: 12 }}>
                        {time}
                    </p>
                </div>
                <div>
                    {flag !== 1 ? (
                        <p
                            className="desc"
                            onClick={event => {
                                this.openImg(event, 1);
                            }}
                            dangerouslySetInnerHTML={{ __html: content }}
                        ></p>
                    ) : null}
                    {!!item.fileList && !!item.fileList.length ? (
                        <div className="msg-content-filelist">
                            {list.length - 1 !== index
                                ? item.fileList.map((vl, index) => {
                                      if (imageFormat.indexOf(vl.fileType) >= 0) {
                                          return (
                                              <div
                                                  className="msg-img-body"
                                                  key={index}
                                                  onClick={() => this.openImg(vl)}
                                              >
                                                  <img key={index} src={vl.fileUrl} alt={vl.fileName} />
                                              </div>
                                          );
                                      } else {
                                          return (
                                              <div className="file-content" key={index}>
                                                  {/*<a className="file-content-down" href={vl.fileUrl} target="_self">*/}
                                                  {/*    <span></span>*/}
                                                  {/*</a>*/}
                                                  <p className="file-name">{vl.fileName}</p>
                                                  <div className="file-body">
                                                      {fileTypeStr.indexOf(vl.fileType) < 0 ? (
                                                          <span className="file-icon">
                                                              <svg>
                                                                  <use xlinkHref="#iconUnknownx" />
                                                              </svg>
                                                          </span>
                                                      ) : (
                                                          fileTypeList.map((vv, nu) => {
                                                              if (vv.type === vl.fileType) {
                                                                  return (
                                                                      <span key={nu} className="file-icon">
                                                                          <svg>
                                                                              <use xlinkHref={vv.icon} />
                                                                          </svg>
                                                                      </span>
                                                                  );
                                                              } else {
                                                                  return null;
                                                              }
                                                          })
                                                      )}
                                                      <a
                                                          className="file-icon file-href"
                                                          href={vl.fileUrl}
                                                          download
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                      >
                                                          <svg>
                                                              <use xlinkHref="#iconxiazai" />
                                                          </svg>
                                                      </a>
                                                  </div>
                                              </div>
                                          );
                                      }
                                  })
                                : null}
                        </div>
                    ) : null}
                </div>
            </div>
        );
    };

    renderText = (LOCALE_HTML, item) => {
        let flag = item.flag;
        let str = '';
        if (item.startType === 1) {
            str = LOCALE_HTML['msg.my.reply'];
            if (item.revocation === 1) {
                str = LOCALE_HTML['msg.my.revoke'];
            }
        } else {
            if (flag === 1) {
                str = LOCALE_HTML['msg.status.created'];
            } else if (flag === 2) {
                str = LOCALE_HTML['msg.status.processing'];
            } else if (flag === 3) {
                str = LOCALE_HTML['msg.status.solved'];
            }
        }
        return <div className="h1">{str}</div>;
    };

    renderStars = score => {
        let arr = [];
        for (let i = 0; i < 5; i++) {
            if (score > i) {
                arr.push(
                    <svg key={i}>
                        <use xlinkHref="#iconxingxing-shiti" />
                    </svg>
                );
            } else {
                arr.push(
                    <svg key={i}>
                        <use xlinkHref="#iconxingxing-weixuanze" />
                    </svg>
                );
            }
        }
        return <div>{arr}</div>;
    };

    onToggle = e => {
        const dom = e.currentTarget;
        if (dom.classList.contains('active')) {
            dom.classList.remove('active');
            this.setState({
                showContentImg: false,
            });
        } else {
            dom.classList.add('active');
            this.setState({
                showContentImg: true,
            });
        }
    };

    onStars = (index, list) => {
        this.setState({
            evaluateTxt: list[index].scoreExplain,
        });

        for (var i = 0; i < list.length; i++) {
            list[i].check = false;
            if (i > index) {
                list[i].check = true;
            }
        }
    };

    onFileChange = ({ fileList }) => {
        fileList = fileList.slice(0, 10);
        fileList = fileList.filter(file => {
            if (file.response) {
                file.url = file.response.url;
            }
            const type = file.name.split('.')[file.name.split('.').length - 1];
            if (fileTypes.indexOf(type.toLocaleLowerCase()) === -1) {
                return false;
            } else if (file.size / 1024 / 1024 > 200) {
                return false;
            } else {
                return file;
            }
        });
        this.setState({
            fileList: fileList,
        });
    };
    beforeUpload = file => {
        const type = file.name.split('.')[file.name.split('.').length - 1];
        if (fileTypes.indexOf(type.toLocaleLowerCase()) === -1) {
            message.error(this.props.LOCALE_HTML['msg.form.uploadError'], 2);
            return false;
        }
        // if (file.size / 1024 / 1024 > 20) {
        //     message.error(this.props.LOCALE_HTML['file.size.limit'], 2);
        //     return false;
        // }
        if (file.size / 1024 / 1024 > 200) {
            message.error(this.props.LOCALE_HTML['file.size.limit'], 2);
            return false;
        }
        if (this.state.fileList.length > 9) {
            message.error(this.props.LOCALE_HTML['file.count.limit'], 2);
            return false;
        }
    };

    render() {
        const {
            isEvalution,
            score,
            remark,
            messageDetail,
            deployConfigInfo,
            LOCALE_HTML,
            ids,
            txtFlag,
            isDefaultButton,
            buttonDesc,
            guideCopyWriting,
            txtDesc,
            dispatch,
        } = this.props;
        const { customerReplyFlag, hiddenReplyFlag } = deployConfigInfo.item || {};
        const { timeStr = '', flag = 1, ticketScoreInfooList } = messageDetail.length > 0 && messageDetail[0];
        const { content = '' } = messageDetail.length > 0 && messageDetail[messageDetail.length - 1];
        // let evaluateVal = '';
        let evaluateList = [];

        if (!!ticketScoreInfooList && !!ticketScoreInfooList.length) {
            for (var i = 0; i < ticketScoreInfooList.length; i++) {
                evaluateList.unshift(ticketScoreInfooList[i]);
            }
        }

        const handleEvaluate = e => {
            this.setState({
                evaluateVal: e.target.value,
            });
        };

        const commitEvaluate = () => {
            let score = '';
            if (commitSign) {
                return;
            }
            commitSign = true;

            this.state.evaluateList.forEach(vl => {
                if (!vl.check) {
                    score = vl.score;
                }
            });

            const _this = this;
            dispatch({
                type: 'leaveMsg/commentService',
                payload: {
                    score: score,
                    textValue: this.state.evaluateVal,
                },
                callback: function (msg) {
                    commitSign = false;
                    if (msg.retCode === '000000') {
                        Toast.success(LOCALE_HTML['comment.suc'], 1);
                        _this.setState({
                            showEvaluate: false,
                            evaluateVal: '',
                        });
                    } else {
                        Toast.fail(LOCALE_HTML['comment.fail'], 1);
                    }
                },
            });
        };

        const handleReply = e => {
            this.setState({
                replyContent: e.target.value,
            });
        };

        const revoke = e => {
            e.preventDefault();
            if (revokeSign) {
                return
            }
            revokeSign = true;
            dispatch({
                type: 'leaveMsg/revokeWorkOrder',
                payload: {},
                callback: function (msg, params) {
                    revokeSign = false;
                    if (msg.retCode === '000000') {
                        Toast.success(LOCALE_HTML['revoke.suc'], 1);
                        setTimeout(() => {
                            dispatch({
                                type: 'leaveMsg/getLeaveMsgDetail',
                                payload: {
                                    ...params,
                                },
                            });
                        }, 1000);
                    } else {
                        Toast.fail(LOCALE_HTML['revoke.fail'], 1);
                    }
                },
            });
        };
        
        const commitReply = () => {
            if (commitSign) {
                return;
            }
            commitSign = true;

            let str = [];
            for (var i = 0; i < this.state.fileList.length; i++) {
                str.push(this.state.fileList[i].url);
            }
            let content = {
                replyContent: this.state.replyContent,
                fileStr: str.join(';'),
            };
            const _this = this;
            dispatch({
                type: 'leaveMsg/commitReplyService',
                payload: {
                    ...content,
                },
                callback: function (msg, params) {
                    commitSign = false;
                    if (msg.retCode === '000000') {
                        _this.setState({
                            replyContent: '',
                            fileList: [],
                            showReply: false,
                        });
                        Toast.success(LOCALE_HTML['reply.suc'], 1);
                        setTimeout(() => {
                            dispatch({
                                type: 'leaveMsg/getLeaveMsgDetail',
                                payload: {
                                    ...params,
                                },
                            });
                        }, 1000);
                    } else {
                        Toast.fail(LOCALE_HTML['reply.fail'], 1);
                    }
                },
            });
        };

        const fileConfig = {
            multiple: true,
            action: '/chat/webchat/fileUploadForPostMsgBypc.action',
            accept: fileTypes,
            data: {
                type: 'ticket',
                pid: ids.companyId,
                uid: ids.uid,
            },
        };
        return (
            <ConfigProvider locale={LOCALE_HTML['msg.language'] === 'cn' ? zhCN : null}>
                <div className="zc-msgDetail-content">
                    <div className="zc-msgDetail-head">
                        <div className="zc-msgDetail-title">
                            <p className="time-title">{timeStr}</p>
                        </div>
                        <div className="zc-msgDetail-text">
                            <input type="checkbox" id="text" />
                            <div className="zc-msgDetail-wrap">
                                <div className="zc-msgDetail-p">
                                    <div dangerouslySetInnerHTML={{ __html: content }}></div>
                                    {messageDetail.length ? (
                                        <div
                                            className="msg-content-filelist msg-top-file"
                                            style={{ display: 'none' }}  //11/1 隐藏
                                            // style={{ display: this.state.showContentImg ? 'block' : 'none' }}
                                        >
                                            {!!messageDetail[messageDetail.length - 1].fileList ? (
                                                <div className="msg-img-wrap">
                                                    {messageDetail[messageDetail.length - 1].fileList.map(
                                                        (vl, index) => {
                                                            if (imageFormat.indexOf(vl.fileType) >= 0) {
                                                                return (
                                                                    <div
                                                                        className="msg-img-body"
                                                                        key={index}
                                                                        onClick={() => this.openImg(vl)}
                                                                    >
                                                                        <img src={vl.fileUrl} alt={vl.fileName} />
                                                                    </div>
                                                                );
                                                            } else {
                                                                return (
                                                                    <div className="file-content" key={index}>
                                                                        {/*<a className="file-content-down" href={vl.fileUrl} download target="_self">*/}
                                                                        {/*    <span></span>*/}
                                                                        {/*</a>*/}
                                                                        <p className="file-name">{vl.fileName}</p>
                                                                        <div className="file-body">
                                                                            {fileTypeStr.indexOf(vl.fileType) < 0 ? (
                                                                                <span className="file-icon">
                                                                                    <svg>
                                                                                        <use xlinkHref="#iconUnknownx" />
                                                                                    </svg>
                                                                                </span>
                                                                            ) : (
                                                                                fileTypeList.map((vv, nu) => {
                                                                                    if (vv.type === vl.fileType) {
                                                                                        return (
                                                                                            <span
                                                                                                key={nu}
                                                                                                className="file-icon"
                                                                                            >
                                                                                                <svg>
                                                                                                    <use
                                                                                                        xlinkHref={
                                                                                                            vv.icon
                                                                                                        }
                                                                                                    />
                                                                                                </svg>
                                                                                            </span>
                                                                                        );
                                                                                    } else {
                                                                                        return null;
                                                                                    }
                                                                                })
                                                                            )}
                                                                            <a
                                                                                className="file-icon file-href"
                                                                                href={vl.fileUrl}
                                                                                download
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                <svg>
                                                                                    <use xlinkHref="#iconxiazai" />
                                                                                </svg>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }
                                                        }
                                                    )}
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            {this.state.show ? (
                                <label
                                    className="msg-detail-more"
                                    htmlFor="text"
                                    onClick={e => {
                                        this.onToggle(e);
                                    }}
                                >
                                    {this.state.showContentImg ? (
                                        <span>
                                            {LOCALE_HTML['msg.collapse']}
                                            <svg className="toggle-icon">
                                                <use xlinkHref="#iconshouqix" />
                                            </svg>
                                        </span>
                                    ) : (
                                        <span>
                                            {LOCALE_HTML['msg.more']}
                                            <svg className="toggle-icon">
                                                <use xlinkHref="#iconshouqi2" />
                                            </svg>
                                        </span>
                                    )}
                                </label>
                            ) : null}
                        </div>
                    </div>
                    <div className="zc-msgDetail-result">
                        <Steps size="small" current={1} direction="vertical">
                            {messageDetail.map((item, index) => {
                                let icon = <i className="icon" />;

                                if (index === 0) {
                                    icon = (
                                        <svg className={`current created ${'status' + item.flag}`}>
                                            <use xlinkHref="#icongongdanzhuangtai" />
                                        </svg>
                                    );
                                }
                                return (
                                    <Step
                                        icon={icon}
                                        key={index}
                                        title={this.renderText(LOCALE_HTML, item)}
                                        description={this.renderStep(item, messageDetail, index)}
                                    />
                                );
                            })}
                        </Steps>
                    </div>
                    {isEvalution === 1 ? (
                        <div className="zc-msgDetail-commentText">
                            <p>{LOCALE_HTML['msg.myservice']}</p>
                            <div className="flex-box">
                                <div className="label">{LOCALE_HTML['msg.score']}</div>
                                {this.renderStars(score)}
                            </div>

                            {!!remark ? (
                                <div className="flex-box">
                                    <div className="label">{LOCALE_HTML['msg.remark']}</div>
                                    <div className="flex-content">{remark}</div>
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </div>
                <div className="zc-msgDetail-bottom">
                    {flag !== 3 ? (
                        <div
                            className="zc-msgDetail-bottom-revoke revoke"
                            onClick={(e) => {revoke(e)}}
                        >
                            {LOCALE_HTML['msg.revoke']}
                        </div>
                    ) : null}
                    {customerReplyFlag === 1 && (flag !== 3 || (flag === 3 && hiddenReplyFlag === 0)) ? (
                        <div
                            className={`zc-msgDetail-bottom-reply ${flag === 3 ? '' : 'single'}`}
                            onClick={this.showModal('showReply')}
                        >
                            {LOCALE_HTML['msg.reply']}
                        </div>
                    ) : null}

                    {flag === 3 && isEvalution === 0 && ticketScoreInfooList ? (
                        <div
                            className={`zc-msgDetail-bottom-evaluate ${
                                customerReplyFlag === 1 && (flag !== 3 || (flag === 3 && hiddenReplyFlag === 0))
                                    ? ''
                                    : 'single'
                            }`}
                            onClick={this.showModal('showEvaluate', evaluateList)}
                        >
                            {LOCALE_HTML['msg.evaluate']}
                        </div>
                    ) : null}
                </div>
                <Modal
                    visible={this.state.showReply}
                    onCancel={this.closeModal('showReply')}
                    centered
                    footer={null}
                    width="340px"
                    wrapClassName="zc-modal-wrap"
                    closeIcon={
                        <svg className="zc-arrow" aria-hidden="true">
                            <use xlinkHref="#iconguanbi2" />
                        </svg>
                    }
                >
                    <div className="zc-pc-modal">
                        <div className="zc-pc-modal-title">
                            <span className="evaluate-title">{LOCALE_HTML['msg.reply']}</span>
                        </div>
                        <div className="zc-pc-modal-content">
                            <div className="zc-pc-modal-content-textarea replay">
                                <TextArea
                                    // defaultValue={this.state.replyContent}
                                    value={this.state.replyContent}
                                    rows={4}
                                    placeholder={LOCALE_HTML['reply.placeholder']}
                                    onChange={handleReply.bind(this)}
                                />
                            </div>
                            <div className="zc-pc-modal-content-upload">
                                <Upload
                                    {...fileConfig}
                                    fileList={this.state.fileList}
                                    onChange={this.onFileChange}
                                    beforeUpload={this.beforeUpload}
                                >
                                    <span className="upload-btn">
                                        <Icon type="paper-clip" className="attachments-icon" />
                                        {LOCALE_HTML['upload.file']}
                                    </span>
                                    <span className="tip-text">({LOCALE_HTML['detail.file.limit']})</span>
                                </Upload>
                            </div>
                            <div className="zc-pc-modal-content-button">
                                <button className="zc-submit-btn" onClick={() => commitReply()}>
                                    {LOCALE_HTML['submit']}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal
                    visible={this.state.showEvaluate}
                    onCancel={this.closeModal('showEvaluate')}
                    centered
                    footer={null}
                    width="340px"
                    wrapClassName="zc-modal-wrap"
                    closeIcon={
                        <svg className="zc-arrow" aria-hidden="true">
                            <use xlinkHref="#iconguanbi2" />
                        </svg>
                    }
                >
                    <div className="zc-pc-modal">
                        <div className="zc-pc-modal-title">
                            <span className="evaluate-title">
                                {guideCopyWriting || LOCALE_HTML['msg.evaluateTitle']}
                            </span>
                        </div>
                        <div className="zc-pc-modal-content">
                            <div className="zc-pc-modal-content-evaluate">
                                {this.state.evaluateList ? (
                                    <ul className="star">
                                        {this.state.evaluateList.map((item, index) => {
                                            let svg = (
                                                <svg>
                                                    <use xlinkHref="#iconxingxing-shiti" />
                                                </svg>
                                            );
                                            if (item.check) {
                                                svg = (
                                                    <svg>
                                                        <use xlinkHref="#iconxingxing-weixuanze" />
                                                    </svg>
                                                );
                                            }
                                            return (
                                                <li key={index} onClick={() => this.onStars(index, evaluateList)}>
                                                    {svg}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                ) : null}
                                <div className="text">{this.state.evaluateTxt}</div>
                            </div>
                            {!!txtFlag ? (
                                <div className="zc-pc-modal-content-textarea">
                                    <TextArea
                                        value={this.state.evaluateVal}
                                        rows={4}
                                        placeholder={txtDesc || LOCALE_HTML['comment.placeholder']}
                                        onChange={handleEvaluate.bind(this)}
                                    />
                                </div>
                            ) : null}

                            <div className="zc-pc-modal-content-button">
                                <button className="zc-submit-btn" onClick={() => commitEvaluate()}>
                                    {isDefaultButton ? LOCALE_HTML['submit'] : buttonDesc}
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <ZoomImg type="pc" />
            </ConfigProvider>
        );
    }
}

const mapState = state => {
    const {
        isEvalution,
        score,
        remark,
        messageDetail,
        txtFlag,
        isDefaultButton,
        buttonDesc,
        guideCopyWriting,
        txtDesc,
    } = state.leaveMsg;
    const { ids, item, fieldConfig, ticketTypeList, sbumitFlag, showType, deployConfigInfo } = state.app;
    const { LOCALE_HTML } = state.locale;
    return {
        isEvalution,
        score,
        remark,
        messageDetail,
        txtFlag,
        ids,
        item,
        fieldConfig,
        ticketTypeList,
        sbumitFlag,
        showType,
        deployConfigInfo,
        LOCALE_HTML,
        isDefaultButton,
        buttonDesc,
        guideCopyWriting,
        txtDesc,
    };
};

export default connect(mapState)(ListDetail);
